module.exports = __webpack_public_path__ + "img/folios--icon.233c576d.svg";